import Service from "./Service";
const resource = "/site";

export default {
  async getData() {
    const resp = await Service.get(`${resource}`);
    const data = resp.data;

    return data;
  },
};
